import React from 'react';
import { Create, SimpleForm } from 'react-admin';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import CustomTextField from '../../../ui/custom-text-field';
import { ContentPageSX } from '../../../styled/custom';
import { minLength, hasValue } from '../../../utils/schemas';

const Schema = Yup.object(
{
  name: minLength(3, "Digite o nome"),
  time: hasValue("Digite o tempo")
});

const TypeSpotCreate = () => (
  <Create
    title="Nova Tempo de Spot"
    redirect="list"
    sx={ContentPageSX}>
    <SimpleForm
      noValidate
      resolver={yupResolver(Schema)}>
      <CustomTextField name="name" label="Nome" fullWidth isRequired />
      <CustomTextField type="number" name="time" label="Tempo" step={10} fullWidth isRequired />
    </SimpleForm>
  </Create>
);

export default TypeSpotCreate;
